import { render } from "./ExpertsView.vue?vue&type=template&id=3077020e&scoped=true"
import script from "./ExpertsView.vue?vue&type=script&lang=js"
export * from "./ExpertsView.vue?vue&type=script&lang=js"

import "./ExpertsView.vue?vue&type=style&index=0&id=3077020e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3077020e"]])

export default __exports__